// Reusable animation styles for consistent motion design across the app

export const animations = {
  // Page entrance
  fadeIn: {
    animation: 'fadeIn 0.4s ease-out',
    '@keyframes fadeIn': {
      from: { opacity: 0 },
      to: { opacity: 1 },
    },
  },

  // Header slide down
  slideDown: {
    animation: 'slideDown 0.5s cubic-bezier(0.16, 1, 0.3, 1)',
    '@keyframes slideDown': {
      from: {
        opacity: 0,
        transform: 'translateY(-20px)',
      },
      to: {
        opacity: 1,
        transform: 'translateY(0)',
      },
    },
  },

  // Content slide up
  slideUp: (delay: number = 0) => ({
    animation: `slideUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) ${delay}s both`,
    '@keyframes slideUp': {
      from: {
        opacity: 0,
        transform: 'translateY(20px)',
      },
      to: {
        opacity: 1,
        transform: 'translateY(0)',
      },
    },
  }),

  // Card scale in
  scaleIn: (delay: number = 0) => ({
    animation: `scaleIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) ${delay}s both`,
    '@keyframes scaleIn': {
      from: {
        opacity: 0,
        transform: 'scale(0.9)',
      },
      to: {
        opacity: 1,
        transform: 'scale(1)',
      },
    },
  }),

  // Staggered card animations
  staggeredCard: (index: number, baseDelay: number = 0.2) => ({
    animation: `scaleIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) ${baseDelay + index * 0.08}s both`,
    '@keyframes scaleIn': {
      from: {
        opacity: 0,
        transform: 'scale(0.9)',
      },
      to: {
        opacity: 1,
        transform: 'scale(1)',
      },
    },
  }),

  // Slide from left
  slideLeft: (delay: number = 0) => ({
    animation: `slideLeft 0.6s cubic-bezier(0.16, 1, 0.3, 1) ${delay}s both`,
    '@keyframes slideLeft': {
      from: {
        opacity: 0,
        transform: 'translateX(-30px)',
      },
      to: {
        opacity: 1,
        transform: 'translateX(0)',
      },
    },
  }),

  // Slide from right
  slideRight: (delay: number = 0) => ({
    animation: `slideRight 0.6s cubic-bezier(0.16, 1, 0.3, 1) ${delay}s both`,
    '@keyframes slideRight': {
      from: {
        opacity: 0,
        transform: 'translateX(30px)',
      },
      to: {
        opacity: 1,
        transform: 'translateX(0)',
      },
    },
  }),

  // Hover effects
  hoverLift: {
    transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
    '&:hover': {
      transform: 'translateY(-4px)',
    },
  },

  hoverLiftScale: {
    transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
    '&:hover': {
      transform: 'translateY(-4px) scale(1.02)',
    },
  },

  // Button animations
  buttonPress: {
    transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
    '&:hover': {
      transform: 'translateY(-2px) scale(1.02)',
    },
    '&:active': {
      transform: 'scale(0.98)',
    },
  },

  // Icon button animations
  iconButtonSpin: {
    transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
    '&:hover': {
      transform: 'scale(1.2) rotate(90deg)',
    },
    '&:active': {
      transform: 'scale(0.9)',
    },
  },

  // List item animations
  listItemSlide: (index: number) => ({
    animation: `slideInRight 0.4s cubic-bezier(0.16, 1, 0.3, 1) ${index * 0.05}s both`,
    '@keyframes slideInRight': {
      from: {
        opacity: 0,
        transform: 'translateX(-20px)',
      },
      to: {
        opacity: 1,
        transform: 'translateX(0)',
      },
    },
  }),

  // Table row animations
  tableRowFade: (index: number) => ({
    animation: `fadeInUp 0.3s ease-out ${index * 0.03}s both`,
    '@keyframes fadeInUp': {
      from: {
        opacity: 0,
        transform: 'translateY(10px)',
      },
      to: {
        opacity: 1,
        transform: 'translateY(0)',
      },
    },
  }),
};

export default animations;
